import { ResultData } from "../../../../../service/Shared";
import {
  CursorDataGrid,
  DataGridColumnDefinition,
  DataGridCursorDataLoadEventHandler,
  ExpandableCard,
} from "../../../../../widget";

export interface DashboardTableCardProps {
  data?: ResultData[];
  columns: DataGridColumnDefinition[];
  title: string;
  expandRoute?: string;
  height?: number;
  isLoading: boolean;
  onChange?: DataGridCursorDataLoadEventHandler;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state?: any;
}

export const DashboardTableCard = ({
  data,
  columns,
  title,
  expandRoute,
  height,
  isLoading,
  onChange,
  state,
}: DashboardTableCardProps): JSX.Element => {
  return (
    <ExpandableCard height={height} title={title} targetRoute={expandRoute} state={state}>
      <CursorDataGrid
        data={data || []}
        onChange={onChange}
        columns={columns}
        clientSide={onChange === undefined}
        pageable={false}
        sortable={false}
        pagination={{ totalCount: data?.length || 0 }}
        dataIsLoading={isLoading}
        noDataMessage="No projects to display"
      />
    </ExpandableCard>
  );
};
